<template>
  <div>
    <el-table :data="tableData" border class="w-full" :height="300" stripe v-loading="loading">
      <el-table-column label="序号" type="index" width="50"></el-table-column>
      <el-table-column
        label="排查任务周期"
        prop="taskTroubleshootCycleStart"
        width="600"
        show-overflow-tooltip
      >
        <template
          slot-scope="scope"
          v-if="scope.row.taskTroubleshootCycleStart && scope.row.taskTroubleshootCycleEnd"
        >
          {{
            scope.row.taskTroubleshootCycleStart &&
              dayjs(scope.row.taskTroubleshootCycleStart).format('YYYY-MM-DD HH:mm:ss')
          }}
          -
          {{
            scope.row.taskTroubleshootCycleEnd &&
              dayjs(scope.row.taskTroubleshootCycleEnd).format('YYYY-MM-DD HH:mm:ss')
          }}
        </template>
      </el-table-column>
      <el-table-column
        label="排查人"
        prop="deadlinePersonName"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        label="任务状态"
        width="120"
        prop="taskStatusStr"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column label="操作" width="80">
        <template slot-scope="scope">
          <el-button
            size="mini"
            @click="handleCheck(scope.row)"
            :disabled="scope.row.taskStatus !== 0 || isCurrentUser(scope.row.deadlinePersonId)"
            >排查</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      @size-change="searchList"
      @current-change="findList"
      :current-page.sync="pageNo"
      :page-size.sync="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :page-sizes="[15, 30, 45, 60, 75, 90]"
      :total="total"
      class="float-right my-20px ml-10px"
    ></el-pagination>
    <el-dialog
      :close-on-click-modal="false"
      title="请输入排查结果"
      :visible.sync="visible"
      class="small-dialog"
      v-dialogDrag
      append-to-body
    >
      <el-form ref="checkResultForm" label-width="150px" :model="checkResultForm">
        <el-form-item
          label="排查结果"
          prop="result"
          :rules="[{ required: true, message: '请选择排查结果', trigger: 'blur' }]"
        >
          <el-radio-group v-model="checkResultForm.result">
            <el-radio :label="0">正常</el-radio>
            <el-radio :label="1">发现隐患</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="flex justify-center">
        <el-button size="small" type="primary" @click="handleSaveResult">{{
          checkResultForm.result === 0 ? '完成任务' : '隐患上报'
        }}</el-button>
        <el-button size="small" @click="visible = false">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import { HiddenDangerInvestigationTaskApi } from '@wiz-api/double-prevention-management'
import { get } from 'lodash'

const hiddenDangerInvestigationTaskApi = new HiddenDangerInvestigationTaskApi()

export default {
  name: 'detail-table',
  props: {
    currentRow: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      userId: undefined,
      taskId: undefined,
      visible: false,
      checkResultForm: {
        result: 0,
      },
      pageNo: 1,
      pageSize: 15,
      // 设备设施清单
      tableData: [],
      loading: false,
      total: 0,
      currentParams: {},
    }
  },
  created() {
    this.searchList()
  },
  computed: {
    isCurrentUser() {
      return (val) => {
        // 获取用户id
        // 获取用户信息，dev环境需要copy到public/config/setting.json,以便拿去本地信息
        const userInfo = Wiz.AuthHooks.GetUserInfo()
        const { sub } = userInfo?.profile
        const userId = sub
        console.log('val', val)
        return !val.split(',').includes(userId)
      }
    },
  },
  methods: {
    handleSaveResult() {
      this.$refs.checkResultForm.validate(async (valid) => {
        if (valid) {
          // 隐患上报跳转新增隐患页面不去改变任务状态，新增时候去改变状态
          if (this.checkResultForm.result === 1) {
            const routerInfo = this.$router.resolve({
              name: 'hidden-list',
            })
            // 跳转判断是不是从待办过来的 传递给隐患上报
            const params = {
              ...this.currentParams,
              isGoTodo: this.$route.query && this.$route.query.mode === 'approve',
            }
            if (routerInfo.href !== '/') {
              this.$router.push({
                name: 'hidden-list',
                params,
              })
              this.visible = false
            } else {
              this.$message({
                showClose: true,
                message: '您暂时没有菜单权限，请联系管理员添加！',
                type: 'warning',
              })
            }
          }
          const [err, res] = await hiddenDangerInvestigationTaskApi.doInvestigation({
            taskId: this.taskId,
            troubleshootingResult: this.checkResultForm.result,
          })
          if (!err) {
            this.$message({
              showClose: true,
              message: '操作成功',
              type: 'success',
            })
            this.visible = false
            this.searchList()
          }
        }
      })
    },
    handleCheck(row) {
      this.taskId = row.id
      this.visible = true
      this.currentParams = {
        ...this.currentRow,
        ...row,
      }
      // inspectionType 隐患来源字段传值
      if (this.currentParams.inspectionType === 0 || this.currentParams.inspectionType) {
        this.currentParams.hiddenDangerSource = this.currentParams.inspectionType
      } else {
        this.currentParams.hiddenDangerSource = this.currentParams.troubleshootingType
      }
    },
    // 搜索 equip 设备设施 job 作业活动
    searchList() {
      this.pageNo = 1
      this.findList()
    },
    // 设备设施列表
    async findList() {
      this.loading = true
      const data = {
        skipCount: (this.pageNo - 1) * this.pageSize,
        maxResultCount: this.pageSize,
        taskId: this.currentRow.id,
      }
      const [err, res] = await hiddenDangerInvestigationTaskApi.taskDetailsPagedListQuery(data)
      if (!err) {
        this.tableData = res.items
        this.total = res.totalCount
      }
      this.loading = false
    },
  },
}
</script>

<style></style>
